import React, { useState } from 'react';

const SchoolBusTracking = () => {
    const tabs = [
        {
            title: "School Bus Tracking", content: {
                // heading: "School Bus Tracking Device",
                // text:
                //     "In today’s fast-paced world, parents and school authorities make the safety of children their top concern during their school travel. A school bus tracking system improves safety by giving both parents and school officials live bus locations so they can supervise school runs more reliably. The systems enable safe and on-time transportation services and represent fundamental requirements for schools committed to safety and operational success. As per the New Government Regulation, starting April 1, 2018, all public transport vehicles including school buses, must have AIS 140 vehicle location tracking device(VLTD) with panic/emergency button. Blackbox provides a comprehensive solution to achieve SAFETY, SECURITY, CONTROL, TRUST, MONITORING, SAVINGS, AND OPTIMAL SCHOOL MANAGEMENT, to manage transportation securely while prioritizing student safety and operational efficiency.",
                head: "Boost School Bus Safety with Advanced GPS Monitoring Addons",
                textadd: "Take control of school transportation and build 100% trust with parents using Veyonta GPS Bus Tracking in India. This advanced Bus GPS Tracker system ensures student safety to run operations smoothly and manage everything effectively. ",
                points: ["Over Speeding – Receive instant alerts when buses are overspeeding to prevent possible hazards.",
                    "Rash Driving – Monitors driving behaviour on their routes to make sure they deliver safe transportation services.",
                    "Geofencing: The geofencing feature for school buses allows real-time tracking and alerts when buses enter or exit predefined safe zones.",
                    "Accidents – Receive instant updates on accidents while tracking the vehicle’s live location accurately in real time.",
                    "Bad Time Keeping – Ensure punctual pick-ups and drop-offs to maintain trust and reliability.",
                    "Negligence in Pick-up and Drops of the Kids – Tracks the bus pick-up and drop-off of students according to their planned schedule. ",
                    "Panic Situations – Provide immediate assistance using the integrated panic button and emergency button.",
                    "Route Deviation – Receive alerts for unscheduled route alterations to protect student safety.",
                    "Student Attendance – Track student boarding and deboarding to keep attendance records correct. ",
                    "Fuel Theft – Monitors fuel usage patterns to protect against illegal consumption of fuel. ",
                    "Driver Authentication & Behavior Monitoring – Ensures only authorized drivers are driving and tracks their behaviour for safety."
                ]
            }
        },
        {
            title: "School Transportation", content: {
                head: "How BlackBox Enhances Control Over School Transportation?",
                textadd: "BlackBox revolutionizes how schools use technology to manage their bus management system and improve each phase of the transportation process. Here we have some of the key features that make it an essential tool for modern school transportation management: ",
                points: ["School Management System(Educonnect) – Blackbox Educonnect gives schools complete control over bus operations through its centralized data management technology.",
                    "Student Management System – The student management system for schools centralizes student data, attendance, grades, and communication, improving administrative efficiency and support.",
                    "Dedicated mobile app – A dedicated app for administrators, teachers, and parents streamlines communication, enhances collaboration, and simplifies access to student information and school updates.",
                    "Advanced AIS 140 GPS Tracking device – Advanced AIS 140 GPS Tracker for Bus provides real-time location tracking, route optimization, and enhanced safety features for improved transportation management."

                ]
            }
        },
        {
            title: "Modern School Management", content: {
                heading: "Why BlackBox is Essential for Modern School Management?",
                text: "Schools take full charge of their transportation operations by using BlackBox monitoring features. Here are some of the key benefits which include:",
                points: ["Advanced Route Management – Optimizes bus routes to make them most effective at both pickup and dropoff times.",
                    "Stoppage Alerts –  Receive alerts when buses come to a stop allowing you to monitor their locations.  ",
                    "Student Update – Track each student’s status to monitor their safety during transportation. ",
                    "Route Deviation Alerts – Receive instant alerts anytime buses depart from their scheduled routes.",
                    "No. of Students Present in the Bus – Monitor the precise number of students aboard to maintain responsibility.  ",
                    "Student Bus Boarding Report – Track student boarding and deboarding for accurate attendance. ",
                    "Speed and Time Monitoring – Monitor vehicle speed and time data to ensure when compliance with safety guidelines. ",
                    "Complete Attendance Report – Access complete student attendance records for better record-keeping. ",
                    "School Bus Time Management – Manage and optimize school bus schedules for punctuality and efficiency.  ",
                    "Less Administration Work – Reduces workplace administration work to help school staff handle tasks more smoothly. ",
                    "Improved Parents-School Relationship – Builds both parents’ and schools’ trust by sharing real-time information about the child’s bus ride.",
                    "Time-Saving – Facilitates faster transportation management saving valuable time."


                ]
            }
        },
        {
            title: "Safety Monitoring", content: {
                heading: " School Bus GPS Tracking System",
                text: "Improve your school vehicle control with Blackbox’s GPS tracking technology protecting students and work better.",
                points: ["Geo-Fencing – Geographic restrictions help buses stay on schedule by sending immediate reports when they go off route.",
                    "Ignition On/Off Status – Monitor when drivers turn on and off their bus engines to track bus usage and fuel consumption.",
                    "Get Accurate Running Time – Record bus trips completely with start and end times for precise travel statistics.",
                    "Route Management – Monitor stoppage locations, durations, and deviations from the planned route for effective management.",
                    "Advance Alerts for parents- Updates the parents about student pick-up/drop-off times and route changes, including exam and holiday updates.",
                    "RFID Card – The RFID card for school buses enables automated student check-ins and check-outs, enhancing safety and attendance tracking.",
                    "Distance Travel Report – Tracks bus routes and saves fuel while optimizing pick-up and drop-off times."]
            }
        },



    ];

    const [activeTab, setActiveTab] = useState(0);

    return (
        <>
            <section className="py-4 px-6 bg-white">
                <div className="max-w-[1400px] mx-auto text-center">
                    <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                        Detailed Information About School Bus Tracking Device
                    </h2>
                    <div className="text-gray-600 text-[16px] md:text-[16px] leading-relaxed space-y-6 text-justify md:text-center">
                        <p>
                            In today’s fast-paced world, parents and school authorities make the safety of children their top concern
                            during their school travel. A school bus tracking system improves safety by giving both parents and
                            school officials live bus locations so they can supervise school runs more reliably. The systems
                            enable safe and on-time transportation services and represent fundamental requirements for schools
                            committed to safety and operational success.
                        </p>
                        <p>
                            As per the New Government Regulation, starting April 1, 2018, all public transport vehicles
                            including school buses, must have AIS 140 vehicle location tracking device (VLTD) with
                            panic/emergency button. Blackbox provides a comprehensive solution to achieve SAFETY, SECURITY,
                            CONTROL, TRUST, MONITORING, SAVINGS, AND OPTIMAL SCHOOL MANAGEMENT, to manage transportation
                            securely while prioritizing student safety and operational efficiency.
                        </p>
                    </div>
                </div>
            </section>
            <section className="max-w-[1400px] mx-auto py-4 px-6 grid md:grid-cols-3 gap-8 md:gap-12 items-start">

                {/* Left Side: Content */}
                <div className="md:col-span-2 order-2 md:order-1">
                    <h2 className="text-3xl font-bold mb-6">{tabs[activeTab].content.heading}</h2>
                    <p className="text-gray-600 mb-8">{tabs[activeTab].content.text}</p>

                    <div className="space-y-4">
                        <h2 className="text-3xl font-bold mb-6">{tabs[activeTab].content.head}</h2>
                        <p className="text-gray-600 mb-8">{tabs[activeTab].content.textadd}</p>
                        {tabs[activeTab].content.points.map((point, i) => (
                            <div key={i} className="flex gap-2">
                                <span className="font-bold shrink-0">•</span>
                                <span className="text-gray-700">{point}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right Side: Sticky Buttons */}
                {/* 2. 'sticky top-24' se buttons scroll ke waqt ruk jayenge */}
                <div className="order-1 md:order-2 flex flex-col gap-4 md:sticky md:top-24">
                    {tabs.map((tab, i) => (
                        <button
                            key={i}
                            onClick={() => setActiveTab(i)}
                            className={`w-full py-3 px-6 rounded-lg font-semibold transition-all duration-300 ${activeTab === i
                                ? "bg-[#f37a23] text-white shadow-lg"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                }`}
                        >
                            {tab.title}
                        </button>
                    ))}
                </div>

            </section>
        </>
    );
};

export default SchoolBusTracking;